import React, { Fragment, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { useToggle } from '../../hooks';

const ITEM_KEY = 'hasSeenCoronaVirusNotice';

export default function CoronaVirusNotice({ onMobile }) {
  const { on, toggle, open } = useToggle(false);

  const handleClick = e => {
    e.preventDefault();
    open();
  };

  useEffect(() => {
    const hasSeenNotice = localStorage.getItem(ITEM_KEY);

    if (!hasSeenNotice) {
      open();
    }

    localStorage.setItem(ITEM_KEY, true);
  }, []);

  return (
    <Fragment>
     <p className={`covid-19 ${ onMobile ? 'd-block d-lg-none':'d-none d-lg-block' }`}>Read about HoneyGuide Refund Policy due to Covid-19 <span onClick={handleClick}>here</span>.</p>
     <Modal isOpen={on} toggle={toggle}>
        <ModalHeader>Refund Policy due to Covid-19 (Corona) Virus:</ModalHeader>
        <ModalBody>
          <ul className="corona-policy">
            <li>Flight Booking- 90% Refund on cancellation upto 3 Days prior to your scheduled booking date</li>
            <li>Lodges- Full Refund up to 48 hours prior to your scheduled booking date.</li>
            <li>Guides- Full Refund up to 7 days prior to your scheduled booking date.</li>
          </ul>
          <ul className="corona-policy" style={{ listStyle: "none" }}>
            <li style={{ listStyle: "none" }}>Note: No charge will be levied and arrangements will be made accordingly if you want to prepone or postpone your bookings.</li>
          </ul>
          <p><button className="btn btn-yellow" onClick={toggle}>I understand</button></p>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
CoronaVirusNotice.defaultProps = {
  onMobile: false,
}


